var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ValidationObserver',{ref:"form",scopedSlots:_vm._u([{key:"default",fn:function({ handleSubmit }){return [_c('form',{attrs:{"autocomplete":_vm.autocomplete},on:{"submit":function($event){$event.preventDefault();return handleSubmit(_vm.onSubmit)}}},[_vm._t("default")],2)]}}],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }